<template>
     <!-- partial:partials/_navbar.html -->
     <nav class="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">
      <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
        <!-- <div class="me-3">
          <button class="navbar-toggler navbar-toggler align-self-center" type="button" data-bs-toggle="minimize">
            <span class="icon-menu"></span>
          </button>
        </div> -->
        <div class="ms-3">
          <router-link class="navbar-brand brand-logo" to="/admin">
            <img src="images/logo.png" alt="logo" />
          </router-link>
          <!-- <router-link class="navbar-brand brand-logo-mini" to="/admin">
            <img src="images/logo-mini.svg" alt="logo" />
          </router-link> -->
          <button class=" ms-2 d-lg-none align-self-center" @click="toggle" type="button">
            <span class="mdi mdi-menu"></span>
          </button>
        </div>
      </div>
      <div v-if="User" class="navbar-menu-wrapper d-flex align-items-top">
        <ul class="navbar-nav">
          <li class="nav-item fw-semibold d-none d-lg-block ms-0">
            <div class="d-flex align-items-center">
              <h1 class="welcome-text d-block">{{ greetingMessage }}, <span class="text-black fw-bold">{{User?.firstName +' ' + User?.lastName}}</span></h1>
              <small class="ms-3">
                <strong>Role - {{ typeof User?.role === 'string' ? User?.role : User?.role?.join(', ') }}</strong>
              </small>
            </div>
            <!-- <h3 class="welcome-sub-text d-block">Your performance summary this week </h3> -->
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <li v-if="checkSuperAdmin != null" @click="backToSuperAdmin()" class="nav-item">
            <span class="h5 text-primary backTo">
              <loader v-if="loaderSuperAdmin" />
              <span class="back" v-if="!loaderSuperAdmin">Back to Super Admin</span>
            </span>
          </li>
          <li v-if="checkAdmin != null" @click="backToAdmin()" class="nav-item">
            <span class="h5 text-primary backTo">
              <loader v-if="loaderAdmin" />
              <span class="back" v-if="!loaderAdmin">Back to Admin</span>
            </span>
          </li>
          <li class="nav-item dropdown user-dropdown">
            <a class="nav-link" id="UserDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
              <img v-if="User?.profileLink == ''" class="img-xs rounded-circle" src="images/faces/face8.jpg" alt="Profile image">
              <img v-if="User?.profileLink != ''" class="img-xs rounded-circle" :src="User?.profileLink" alt="Profile image"> 
            </a>
            <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="UserDropdown">
              <div class="dropdown-header text-center">
                <!-- <img class="img-md rounded-circle" src="images/faces/face8.jpg" alt="Profile image"> -->
                <p class="mb-1 mt-3 fw-semibold">{{User?.firstName + ' ' + User?.lastName}}</p>
                <p class="fw-light text-muted mb-0">{{User?.email}}</p>
              </div>
              <a class="dropdown-item"><i class="dropdown-item-icon mdi mdi-account-outline text-primary me-2"></i> My
                Profile </a>
              <router-link v-if="User?.role === 'AD'" to="/user-subscriptions" class="dropdown-item">
                <i class="dropdown-item-icon mdi mdi-calendar-check-outline text-primary me-2"></i> My subscriptions
              </router-link>
              <router-link v-if="User?.role === 'AD'" to="/user-transactions" class="dropdown-item">
                <i class="dropdown-item-icon mdi mdi-cash-100 text-primary me-2"></i> My transactions
              </router-link>
              <a @click="logout()" class="dropdown-item">
                <i class="dropdown-item-icon mdi mdi-power text-primary me-2"></i>
                <span>Logout</span>
                <loader v-if="loader" />
              </a>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    <!-- partial -->
</template>
    
<script>
import loader from '../loader.vue';

export default {
  name: "HeaderPage",
  props: {
    msg: String,
  },

  components: {
        loader
    },

    data(){
        return{
            loaderSuperAdmin: false,
            loaderAdmin: false,
            currentHour: new Date().getHours(), // Gets the current hour (0-23)
            checkSuperAdmin: '',
            checkAdmin: '',
        }
    },

    created(){
      this.checkSuperAdmin = localStorage.getItem('superAdminToken')
      this.checkAdmin = localStorage.getItem('adminToken')
    },

    computed:{
      User(){
        return this.$store.state.auth.user;
      },

      greetingMessage() {
        if (this.currentHour < 12) {
          return "Good Morning";
        } else if (this.currentHour < 18) {
          return "Good Afternoon";
        } else {
          return "Good Evening";
        }
      },
    },

    methods: {
      logout(){
        this.loader = true;
        this.$store.dispatch('logout',{
          userToken: localStorage.getItem('token'),
          name: 'admin',
        })
        .then((res)=>{
            console.log("res", res);
            this.loader = false;
        })
        .catch((err)=>{ 
            console.log("err", err);
            this.loader = false;
        })
      },

      toggle() {
        this.$emit('toggleSidebar');
      },



      backToSuperAdmin(){
        this.loaderSuperAdmin = true;
        // return
        this.$store
          .dispatch("BackToSuperAdmin")
          .then(() => {
            this.loaderSuperAdmin = false;
            localStorage.removeItem('adminToken');
          })
          .catch(() => {
            this.loaderSuperAdmin = false;
          });
      },

      backToAdmin(){
        this.loaderAdmin = true;
        // return
        this.$store
          .dispatch("BackToAdmin")
          .then(() => {
            this.loaderAdmin = false;
            localStorage.removeItem('adminToken');
          })
          .catch(() => {
            this.loaderAdmin = false;
          });
      }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.backTo{
  cursor: pointer;
}
.back{
  background: #000000;
  padding: 10px;
  border-radius: 5px;
  color: white;
}
</style>
                                    